// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-recruiter-container {
  padding: 24px;
  max-width: 95%;
  margin: 0 auto;
}

h2 {
  margin-bottom: 20px;
  font-size: 22px;
  color: #333;
}

.role-selector {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}

.role-selector mat-form-field:first-child {
  width: 600px;
}

.model-selector {
  width: 220px;
}

.model-cost {
  font-size: 11px;
  color: #888;
}

.chat-wrapper {
  margin-top: 24px;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: rgba(99, 99, 99, 0.1) 0px 2px 8px 0px;
}

.chat-container {
  height: 480px;
  overflow-y: auto;
  padding: 20px 16px;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.message-row {
  display: flex;
}

.message-row.assistant {
  justify-content: flex-start;
}

.message-row.user {
  justify-content: flex-end;
}

.bubble {
  max-width: 72%;
  padding: 10px 14px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.5;
}

.message-row.assistant .bubble {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 2px 12px 12px 12px;
  color: #333;
}

.message-row.user .bubble {
  background-color: #de8a13;
  border-radius: 12px 2px 12px 12px;
  color: #fff;
}

.sender-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 4px;
  opacity: 0.7;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.bubble p {
  margin: 0;
  white-space: pre-wrap;
}

.loading-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 0;
}

.loading-text {
  font-size: 13px;
  color: #888;
}

.input-row {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding: 12px 16px;
  background-color: #fff;
  border-top: 1px solid #e0e0e0;
}

.input-field {
  flex: 1;
}

.send-btn {
  height: 44px;
  min-width: 80px;
  background-color: #de8a13 !important;
}

.save-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background-color: #fff;
  border-top: 1px solid #e0e0e0;
}

.complete-label {
  font-size: 14px;
  color: #555;
  font-style: italic;
}

.save-btn {
  background-color: #de8a13 !important;
  color: #fff;
}

/* RECOMMENDATIONS */
.recommendations-section {
  margin-top: 32px;
}

.rec-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.rec-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.find-btn {
  background-color: #de8a13 !important;
  color: #fff !important;
}

.rec-loading {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
  color: #666;
  font-size: 14px;
}

.candidate-cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.candidate-card {
  border-radius: 10px;
  padding: 18px 20px;
  background: #fff;
  border: 1px solid #e0e0e0;
}

.card-header {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.candidate-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.candidate-meta {
  font-size: 13px;
  color: #777;
}

.round-badge {
  margin-left: auto;
  font-size: 11px;
  background: #f0f0f0;
  color: #555;
  padding: 2px 8px;
  border-radius: 10px;
}

.card-reason {
  margin-bottom: 14px;
}

.reason-label {
  font-size: 12px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.card-reason p {
  margin: 4px 0 0;
  font-size: 14px;
  color: #444;
  line-height: 1.5;
}

.card-actions {
  display: flex;
  gap: 10px;
}

.accept-btn {
  background-color: #4caf50 !important;
  color: #fff !important;
}

.reject-btn {
  color: #e53935 !important;
  border-color: #e53935 !important;
}

.reject-submit-btn {
  background-color: #e53935 !important;
  color: #fff !important;
  margin-top: 6px;
}

.reject-input {
  margin-top: 10px;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
  margin-top: 8px;
}

.status-badge.accepted {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.status-badge.rejected {
  background-color: #ffebee;
  color: #c62828;
}

.find-more-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  padding: 14px 16px;
  background: #fff8f0;
  border: 1px solid #f0d9b5;
  border-radius: 8px;
}

.find-more-label {
  font-size: 14px;
  color: #555;
}
`, "",{"version":3,"sources":["webpack://./src/app/ai-recruiter/ai-recruiter.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":[".ai-recruiter-container {\n  padding: 24px;\n  max-width: 95%;\n  margin: 0 auto;\n}\n\nh2 {\n  margin-bottom: 20px;\n  font-size: 22px;\n  color: #333;\n}\n\n.role-selector {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.role-selector mat-form-field:first-child {\n  width: 600px;\n}\n\n.model-selector {\n  width: 220px;\n}\n\n.model-cost {\n  font-size: 11px;\n  color: #888;\n}\n\n.chat-wrapper {\n  margin-top: 24px;\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: rgba(99, 99, 99, 0.1) 0px 2px 8px 0px;\n}\n\n.chat-container {\n  height: 480px;\n  overflow-y: auto;\n  padding: 20px 16px;\n  background-color: #fafafa;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.message-row {\n  display: flex;\n}\n\n.message-row.assistant {\n  justify-content: flex-start;\n}\n\n.message-row.user {\n  justify-content: flex-end;\n}\n\n.bubble {\n  max-width: 72%;\n  padding: 10px 14px;\n  border-radius: 12px;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.message-row.assistant .bubble {\n  background-color: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 2px 12px 12px 12px;\n  color: #333;\n}\n\n.message-row.user .bubble {\n  background-color: #de8a13;\n  border-radius: 12px 2px 12px 12px;\n  color: #fff;\n}\n\n.sender-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  margin-bottom: 4px;\n  opacity: 0.7;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.bubble p {\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n.loading-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 4px 0;\n}\n\n.loading-text {\n  font-size: 13px;\n  color: #888;\n}\n\n.input-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  padding: 12px 16px;\n  background-color: #fff;\n  border-top: 1px solid #e0e0e0;\n}\n\n.input-field {\n  flex: 1;\n}\n\n.send-btn {\n  height: 44px;\n  min-width: 80px;\n  background-color: #de8a13 !important;\n}\n\n.save-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  background-color: #fff;\n  border-top: 1px solid #e0e0e0;\n}\n\n.complete-label {\n  font-size: 14px;\n  color: #555;\n  font-style: italic;\n}\n\n.save-btn {\n  background-color: #de8a13 !important;\n  color: #fff;\n}\n\n/* RECOMMENDATIONS */\n.recommendations-section {\n  margin-top: 32px;\n}\n\n.rec-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.rec-header h3 {\n  margin: 0;\n  font-size: 18px;\n  color: #333;\n}\n\n.find-btn {\n  background-color: #de8a13 !important;\n  color: #fff !important;\n}\n\n.rec-loading {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 0;\n  color: #666;\n  font-size: 14px;\n}\n\n.candidate-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.candidate-card {\n  border-radius: 10px;\n  padding: 18px 20px;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n}\n\n.card-header {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n}\n\n.candidate-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.candidate-meta {\n  font-size: 13px;\n  color: #777;\n}\n\n.round-badge {\n  margin-left: auto;\n  font-size: 11px;\n  background: #f0f0f0;\n  color: #555;\n  padding: 2px 8px;\n  border-radius: 10px;\n}\n\n.card-reason {\n  margin-bottom: 14px;\n}\n\n.reason-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #888;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.card-reason p {\n  margin: 4px 0 0;\n  font-size: 14px;\n  color: #444;\n  line-height: 1.5;\n}\n\n.card-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.accept-btn {\n  background-color: #4caf50 !important;\n  color: #fff !important;\n}\n\n.reject-btn {\n  color: #e53935 !important;\n  border-color: #e53935 !important;\n}\n\n.reject-submit-btn {\n  background-color: #e53935 !important;\n  color: #fff !important;\n  margin-top: 6px;\n}\n\n.reject-input {\n  margin-top: 10px;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 600;\n  margin-top: 8px;\n}\n\n.status-badge.accepted {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.status-badge.rejected {\n  background-color: #ffebee;\n  color: #c62828;\n}\n\n.find-more-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 20px;\n  padding: 14px 16px;\n  background: #fff8f0;\n  border: 1px solid #f0d9b5;\n  border-radius: 8px;\n}\n\n.find-more-label {\n  font-size: 14px;\n  color: #555;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
